import { css } from '@compiled/react';

import { useCohort } from '@/components/user-context/helpers/cohorts';
import type { ExistingSite } from '@/libraries/bxp-web-stargate-client/src/hook/use-bxp-web-stargate-client.types';

import { SiteActivationContextProvider } from './hooks/site-activation-context';
import { SiteActivationSwitcher } from './site-activation-switcher';

export const SiteActivation = (props: {
	ExistingUser?: React.ReactNode;
	ManagedUser?: React.ReactNode;
	NewUser?: React.ReactNode;
	WeekOneUser?: React.ReactNode;
	UpgradeEligibleUser?: React.ReactNode;
	CurrentProductJoinableUser?: React.ReactNode;
	CurrentProductUser?: React.ReactNode;
	UpliftEligibleUser?: React.ReactNode;
	CrossflowEligibleUser?: React.ReactNode;
	existingSites?: ExistingSite[];
	useContactExpandCohortLogic?: boolean;
	autoActivateWithRecommendedName?: boolean;
}) => {
	const cohort = useCohort(props.useContactExpandCohortLogic);

	return (
		<div css={siteActivationCss} data-testid="site-activation" data-cohort={cohort}>
			<SiteActivationContextProvider
				existingSites={props.existingSites}
				useContactExpandCohortLogic={props.useContactExpandCohortLogic}
				autoActivateWithRecommendedName={props.autoActivateWithRecommendedName}
			>
				<SiteActivationSwitcher {...props} />
			</SiteActivationContextProvider>
		</div>
	);
};

// fill the available space in the parent container
const siteActivationCss = css({
	display: 'flex',
	flexDirection: 'column',
	flexGrow: 1,
});
